import React from 'react';

const base = 'bg-neutral-200 animate-pulse';

export const Skeleton = ({ className = '', shape = 'rect' }) => {
  const shapeCls = shape === 'circle' ? 'rounded-full' : shape === 'text' ? 'rounded' : 'rounded-md';
  return <div className={`${base} ${shapeCls} ${className}`} />;
};

export const SkeletonText = ({ lines = 1, className = '' }) => (
  <div className={`space-y-2 ${className}`}>
    {Array.from({ length: lines }).map((_, i) => (
      <div
        key={i}
        className={`${base} rounded h-3 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`}
      />
    ))}
  </div>
);

// One placeholder table row. Cell widths vary slightly so the shimmer doesn't look uniform.
export const SkeletonRow = ({ cols = 4 }) => (
  <tr className="border-b border-neutral-100">
    {Array.from({ length: cols }).map((_, i) => {
      const widths = ['w-3/4', 'w-1/2', 'w-1/3', 'w-2/5', 'w-3/5'];
      return (
        <td key={i} className="p-3">
          <div className={`${base} h-3 rounded ${widths[i % widths.length]}`} />
        </td>
      );
    })}
  </tr>
);

export const SkeletonTable = ({ rows = 5, cols = 4 }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <SkeletonRow key={i} cols={cols} />
    ))}
  </>
);

export const SkeletonCard = ({ className = '' }) => (
  <div className={`bg-white border border-neutral-200 rounded-lg p-5 space-y-3 ${className}`}>
    <div className={`${base} h-3 rounded w-1/3`} />
    <div className={`${base} h-7 rounded w-1/2`} />
  </div>
);

export default Skeleton;
